import React, {useState, useEffect} from 'react';

const NoInternetConnection = (props) => {
    // state variable holds the state of the internet connection
    const [isOnline, setOnline] = useState(true);

    // On initization set the isOnline state.
    useEffect(()=>{
        setOnline(navigator.onLine)
    },[])

    // event listeners to update the state 
    window.addEventListener('online', () => {
        setOnline(true)
    });

    window.addEventListener('offline', () => {
        setOnline(false)
    });

    // if user is online, return the child component else return a custom component
    if(isOnline){
    return(
        props.children
    )
    } else {
        return(

            <div id="divErrorGeneral" className="loader">
                <section id="sectionErrorGeneral" className="error-container">
                  <div id="divIconoErrorGeneral" className="message error huge">
                    <span id="spanIconErrorGeneral" className="material-icon">wifi_off</span> 
                    <h1 id="h1ErrorGeneral" className="title">SIN CONEXIÓN</h1>
                    <p id="textoErrorGeneral">No tienes conexión a internet, revísala y vuelve a intentarlo.</p>
                  </div>
                  <ul className="actions">                    
                    <button className="button primary" onClick={() => window.location.href="/"}>Reintentar</button>                    
                  </ul>
                </section>
              </div>

        )
    }
}

export default NoInternetConnection;